import Icon from '../components/Icon.vue'

Icon.register({
  rocket: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9C76.7 128 60.1 138.3 52 154.5L2.6 253.3C-5.4 269.3 6.2 288 24.1 288H119.2C113.3 300.8 107.3 313.5 101.2 325.7 98.1 331.9 99.3 339.3 104.2 344.2L167.8 407.8C172.7 412.7 180.1 413.9 186.3 410.8 198.5 404.7 211.2 398.8 224 392.9V488C224 505.8 242.8 517.4 258.7 509.5L357.4 460.1C373.7 452 383.9 435.3 383.9 417.2V312.8C456.5 266.5 511.9 204.4 511.9 101.7 512 76.5 512 51.3 505.1 19.1zM400 160C373.5 160 352 138.5 352 112S373.5 64 400 64 448 85.5 448 112 426.5 160 400 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rocket.js
// module id = vhbr
// module chunks = 144